import type { SimpleBoard } from "../levelgenerator/simpleBoard";
import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OpenBlastDoorsTerminal } from "./openBlastDoorsTerminal";
import { RobotSpawner } from "./robotSpawner";
import { TerminalState } from "./terminal";

export class RobotEntranceTerminal extends OpenBlastDoorsTerminal {
	static key = "RobotEntranceTerminal";
	constructor(xy: XY, doorId?: string) {
		super(xy, doorId);
	}

	static override initOnBoard(xy: XY, board: SimpleBoard, props?: Record<string, unknown>): PhysicalThing[] {
		const terminal = new RobotEntranceTerminal(xy, props?.group as string | undefined);
		board.putThing(terminal);
		return [terminal];
	}

	runTerminalAction(): void {
		super.runTerminalAction();
		const board = this.board!;
		for (const thing of board.getPhysicalThings()) {
			if (thing instanceof RobotSpawner) {
				thing.setActive(true);
			}
		}
	}

	static deserialize(data: any): RobotEntranceTerminal {
		const t = new RobotEntranceTerminal(deserializeXY(data.xy), data.doorId ?? undefined);
		t.visualId = data.visualId;
		t.state = data.state ?? TerminalState.ACTIVE;
		return t;
	}
}
